import { useMutableRef } from '@carnica/utils/hooks';
import { useEffect, useRef } from 'react';
export var useScrollDetector = function useScrollDetector(ref, _ref) {
  var _ref$deps = _ref.deps,
    deps = _ref$deps === void 0 ? [] : _ref$deps,
    onStartScrolling = _ref.onStartScrolling,
    onStopScrolling = _ref.onStopScrolling,
    onScroll = _ref.onScroll,
    _ref$scrollTimeout = _ref.scrollTimeout,
    scrollTimeout = _ref$scrollTimeout === void 0 ? 300 : _ref$scrollTimeout;
  var timerRef = useRef(null);
  var isScrollableRef = useRef(false);
  var scrollTimeoutRef = useMutableRef(scrollTimeout);
  var detectSroll = function detectSroll(e) {
    onScroll === null || onScroll === void 0 || onScroll(e);
    if (timerRef.current !== null) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(function () {
      isScrollableRef.current = false;
      onStopScrolling === null || onStopScrolling === void 0 || onStopScrolling(e);
    }, scrollTimeoutRef.current);
    if (!isScrollableRef.current) {
      onStartScrolling === null || onStartScrolling === void 0 || onStartScrolling(e);
      isScrollableRef.current = true;
    }
  };
  useEffect(function () {
    var _ref$current;
    (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.addEventListener('scroll', detectSroll);
    return function () {
      var _ref$current2;
      (_ref$current2 = ref.current) === null || _ref$current2 === void 0 || _ref$current2.removeEventListener('scroll', detectSroll);
    };
  }, deps);
};